import { FC, ReactNode } from 'react'
import { FormQuestionAvatar, FormQuestionAvatarType } from './Avatar'

const FormQuestion: FC & FormQuestionAvatarType = (): ReactNode => <></>

FormQuestion.Avatar = FormQuestionAvatar

export default FormQuestion
